export default __webpack_public_path__ + "static/media/heineken-back-black.d31f88b7.jpg";